import { useState, useEffect } from 'react'
import { getFeatureFlag } from 'ggx-service/feature-flag/selectors'
import { featureFlagService } from 'ggx-service/feature-flag/feature-flag'

export function useFeatureFlagFromExternalStore(flagName, store) {
  const [featureFlag, setFeatureFlag] = useState(() =>
    getFeatureFlag({
      state: store.getState(),
      featureFlag: flagName,
    })
  )
  useEffect(() => {
    return store.subscribe(() => {
      const flag = getFeatureFlag({
        state: store.getState(),
        featureFlag: flagName,
      })
      if (flag !== featureFlag) setFeatureFlag(flag)
    })
  }, [])
  return featureFlag
}

export function useFeatureFlagConfig(flagName) {
  const [featureFlagValue, setFeatureFlagValue] = useState(
    featureFlagService.getFeatureWithConfig(flagName)
  )
  useEffect(() => {
    featureFlagService.triggerFeatureFlag(flagName).then(() => {
      setFeatureFlagValue(featureFlagService.getFeatureWithConfig(flagName))
    })
  }, [])
  return featureFlagValue
}
